import { useEffect, useRef } from 'react';
export default function useTimerRef() {
    const timerRef = useRef();
    useEffect(() => () => {
        clearTimeout(timerRef.current);
    }, []);
    return timerRef;
}
